module.exports = __webpack_public_path__ + "img/border_rectangle1.83938772.svg";